module.exports = __webpack_public_path__ + "media/images/lb/129-1fadf57b6df2fc40059b67dd413aa0dc.svg";